export type SelectedValueListItem = Record<string, string>

export enum AutocompleteSelectEvents {
  REMOTE_METHOD = 'remoteMethod',
  CLEAR_SEARCH_RESULT = 'clearSearchResult',
  AUTOCOMPLETE_SEARCH = 'autocompleteSearch',
  UPDATE_SELECTED_VALUE_LIST = 'update:selectedValueList',
}
